import { createContext, useContext, useState } from "react";
import { translations } from "../lib/i18n";
import api from "../lib/api";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ssa_lang") || "el");

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("ssa_lang", l);
    api.put("/auth/lang", { lang: l }).catch(() => {});
  };

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
